import {
    AppliedBillableConceptExtraFieldsPatchInBatchRequest,
    AppliedBillableConceptResponse
} from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { BillableDeliveryNoteResponse } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { CustomerResponse } from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { CancelTokenSource } from 'axios'

export interface BillingModalDeliveryNotesCrudParams {
    appliedBillableConcepts?: AppliedBillableConceptResponse[]
    deliveryNote?: BillableDeliveryNoteResponse
}

export interface BillingModalDeliveryNotesCrudState {
    appliedBillableConcepts: AppliedBillableConceptResponse[]
    appliedBillableConceptsToUpdate: AppliedBillableConceptExtraFieldsPatchInBatchRequest[]
    deliveryNote: StrictNullable<BillableDeliveryNoteResponse>
    deliveryNoteConceptsCount: number
    customer: StrictNullable<CustomerResponse>
    source: StrictNullable<CancelTokenSource>
}
export const initialBillingModalDeliveryNotesCrudState =
    (): BillingModalDeliveryNotesCrudState => ({
        appliedBillableConcepts: [],
        appliedBillableConceptsToUpdate: [],
        deliveryNote: null,
        deliveryNoteConceptsCount: 0,
        customer: null,
        source: null
    })
